export default "__VITE_ASSET__$jGyCKRX__"